import { IAPgetOfferings, IAPupdateOfferings } from "@/utils/iap";
import { cacheOfferingsResponse } from "@/utils/iap/iap-cache";
import { trialDaysLeft, trialMinutesLeft } from "@/utils/iap/trial-days";

// TODO: improve type inference
const flutterPaymentMixin = {
    data: () => ({
        iapStatus: window.IAP.status,
    }),
    created() {
        this.registerBusEvent("flutter:getOfferings", this.updateOfferings);
        this.registerBusEvent("flutter:updateFirstRunTS", this.updateFirstRunTS);
        this.registerBusEvent('flutter:paymentError', this.handlePaymentResponse); // @TODO will be removed from flutter
        this.registerBusEvent('flutter:paymentSucceed', this.handlePaymentSucceed);
        this.registerBusEvent('flutter:paymentFailed', this.handlePaymentFailed);
        this.registerBusEvent("flutter:lifecycleStateChanged", (data) => {
            if (data.state === "true" || data.state === true) {
                IAPgetOfferings();
            }
        });
        IAPgetOfferings();
        this.setIsPro();

        window.events.on('*', (type, event) => {
            if (event === 'iapError') {
                return this.handlePaymentResponse(event);
            }

            if (event === 'iapSuccess') {
                this.handlePaymentResponse({ event, ...{ text: 'Finished' } });
            }
        });
    },
    methods: {
        setIsPro() {
            let isPro = false;

            try {
                // isPro = Date.now() < Date.parse('2021-02-22 07:00:00 GMT'); // free weekend
                if (trialMinutesLeft() > 0) {
                    console.log('isPro: within free start period');
                    isPro = true;
                }
                /* IMPORTANT: VIDEO IDS HAS CHANGED! ADD SOME NEW IDS TO THE FREE VIDEO IDS LIST */
                // if (!this.$isIOS()) isPro = true; // temp fix
                else if (this.$packageName !== "com.denticalc.4in1") {
                    console.log('isPro: not using com.denticalc.4in1');
                    isPro = true;
                }
                else if (window.IAP.hasAccessToComponent('premium')) {
                    console.log('isPro: subscribed user');
                    isPro = true;
                }
                else if (!window.IAP.status.includes('offeringsLoaded') && localStorage.getItem('isProSubscribed') !== null) {
                    console.log('isPro: use stored value');
                    isPro = localStorage.getItem('isProSubscribed') === "true";
                }
            }
            catch (error) {
                captureException(error);

                isPro = false;
            }
            this.$store.state.isPro = isPro;

            localStorage.setItem('isProSubscribed', String(isPro));
        },
        updateFirstRunTS() {
            this.setIsPro();
        },
        /** @type {(data: Record<"offerings", Array<Product>>) => void} */
        updateOfferings(data) {
            cacheOfferingsResponse(data);
            IAPupdateOfferings(data);
            this.setIsPro();
            this.$bus.$emit("flutter:onOfferingsUpdated");
            // this.$forceUpdate();
        },
        /** @type {(data?: Record<string, string>) => void} */
        handlePaymentResponse(data) {
            if (data.text === 'Finished') this.handlePaymentSucceed();
            else this.handlePaymentFailed();
        },
        /** @type {(data?: Record<string, string>) => void} */
        handlePaymentSucceed(data) {
            window.IAP.onSuccess(data);
            this.setIsPro();
            this.$bus.$emit('subscribe:process', false);
            this.$forceUpdate(); // @TODO still required?
        },
        /** @type {(data?: Record<string, string>) => void} */
        handlePaymentFailed(data) {
            if (data) window.IAP.onError(data);
            this.$bus.$emit('subscribe:cancelled');
            this.$forceUpdate();
            this.$bus.$emit('openAppDialog','storeErrorDialog');
        },
    },
};

export default flutterPaymentMixin;
